var _rect, _polygon, _polygon2, _polygon3, _line, _line2, _line3, _line4, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _line5, _line6, _line7, _line8, _polygon11, _line9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "#1c1530"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80,12 110,42 80,34 50,42",
    fill: "#3e2c5e"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,12 110,42 80,34",
    fill: "#5c3a8a",
    opacity: 0.75
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,12 50,42 80,34",
    fill: "#4a2a6a",
    opacity: 0.85
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 12,
    x2: 110,
    y2: 42,
    stroke: "#c09840",
    strokeWidth: 1.2,
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 12,
    x2: 50,
    y2: 42,
    stroke: "#c09840",
    strokeWidth: 1.2,
    opacity: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 42,
    x2: 80,
    y2: 34,
    stroke: "#f0e0c8",
    strokeWidth: 0.6,
    opacity: 0.45
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 42,
    x2: 80,
    y2: 34,
    stroke: "#5ab4ac",
    strokeWidth: 0.6,
    opacity: 0.45
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "50,42 110,42 130,72 80,108 30,72",
    fill: "#2a1840"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,34 110,42 130,72 80,108",
    fill: "#3a2458"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,34 50,42 30,72 80,108",
    fill: "#2d1e48"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "50,42 110,42 125,65 35,65",
    fill: "#5c3a8a",
    opacity: 0.35
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,34 108,42 94,56",
    fill: "#5ab4ac",
    opacity: 0.4
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,34 52,42 66,56",
    fill: "#f0e0c8",
    opacity: 0.22
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,92 90,76 94,56 80,62",
    fill: "#c09840",
    opacity: 0.28
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 42,
    x2: 130,
    y2: 72,
    stroke: "#c09840",
    strokeWidth: 1,
    opacity: 0.55
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 42,
    x2: 30,
    y2: 72,
    stroke: "#c09840",
    strokeWidth: 1,
    opacity: 0.55
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 72,
    x2: 80,
    y2: 108,
    stroke: "#c09840",
    strokeWidth: 0.8,
    opacity: 0.45
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 72,
    x2: 80,
    y2: 108,
    stroke: "#c09840",
    strokeWidth: 0.8,
    opacity: 0.45
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,12 87,22 80,18 73,22",
    fill: "#f0e0c8",
    opacity: 0.7
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 72,
    x2: 130,
    y2: 72,
    stroke: "#c09840",
    strokeWidth: 0.5,
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk4);
export default __webpack_public_path__ + "static/media/talk4.549cdab28cac051279161ff9721d4bf7.svg";
export { ForwardRef as ReactComponent };